import { render, staticRenderFns } from "./txzyzd.vue?vue&type=template&id=0818c40a&scoped=true&"
import script from "./txzyzd.vue?vue&type=script&lang=js&"
export * from "./txzyzd.vue?vue&type=script&lang=js&"
import style0 from "./txzyzd.vue?vue&type=style&index=0&id=0818c40a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0818c40a",
  null
  
)

export default component.exports